import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { useControlledState } from "@react-stately/utils";
import { useMemo, useRef, useState } from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/**
 * A Selection is a special Set containing Keys, which also has an anchor
 * and current selected key for use when range selecting.
 */

var $c91e86e24f2dc9a2182dcc2674c58c$export$Selection = /*#__PURE__*/function (_Set) {
  _inherits($c91e86e24f2dc9a2182dcc2674c58c$export$Selection, _Set);

  var _super = _createSuper($c91e86e24f2dc9a2182dcc2674c58c$export$Selection);

  function $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(keys, anchorKey, currentKey) {
    var _this;

    _classCallCheck(this, $c91e86e24f2dc9a2182dcc2674c58c$export$Selection);

    _this = _super.call(this, keys);
    _this.anchorKey = void 0;
    _this.currentKey = void 0;

    if (keys instanceof $c91e86e24f2dc9a2182dcc2674c58c$export$Selection) {
      _this.anchorKey = anchorKey || keys.anchorKey;
      _this.currentKey = currentKey || keys.currentKey;
    } else {
      _this.anchorKey = anchorKey;
      _this.currentKey = currentKey;
    }

    return _this;
  }

  return $c91e86e24f2dc9a2182dcc2674c58c$export$Selection;
}( /*#__PURE__*/_wrapNativeSuper(Set));
/**
 * Manages state for multiple selection and focus in a collection.
 */


export function useMultipleSelectionState(props) {
  var _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
      disallowEmptySelection = props.disallowEmptySelection; // We want synchronous updates to `isFocused` and `focusedKey` after their setters are called.
  // But we also need to trigger a react re-render. So, we have both a ref (sync) and state (async).

  var isFocusedRef = useRef(false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      _setFocused = _useState2[1];

  var focusedKeyRef = useRef(null);
  var childFocusStrategyRef = useRef(null);

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      _setFocusedKey = _useState4[1];

  var selectedKeysProp = useMemo(function () {
    return $c86d35e876e048ac11515eee40c7$var$convertSelection(props.selectedKeys);
  }, [props.selectedKeys]);
  var defaultSelectedKeys = useMemo(function () {
    return $c86d35e876e048ac11515eee40c7$var$convertSelection(props.defaultSelectedKeys, new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection());
  }, [props.defaultSelectedKeys]);

  var _useControlledState = useControlledState(selectedKeysProp, defaultSelectedKeys, props.onSelectionChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      selectedKeys = _useControlledState2[0],
      setSelectedKeys = _useControlledState2[1];

  var disabledKeysProp = useMemo(function () {
    return props.disabledKeys ? new Set(props.disabledKeys) : new Set();
  }, [props.disabledKeys]);
  return {
    selectionMode: selectionMode,
    disallowEmptySelection: disallowEmptySelection,

    get isFocused() {
      return isFocusedRef.current;
    },

    setFocused: function setFocused(f) {
      isFocusedRef.current = f;

      _setFocused(f);
    },

    get focusedKey() {
      return focusedKeyRef.current;
    },

    get childFocusStrategy() {
      return childFocusStrategyRef.current;
    },

    setFocusedKey: function setFocusedKey(k, childFocusStrategy) {
      if (childFocusStrategy === void 0) {
        childFocusStrategy = 'first';
      }

      focusedKeyRef.current = k;
      childFocusStrategyRef.current = childFocusStrategy;

      _setFocusedKey(k);
    },
    selectedKeys: selectedKeys,
    setSelectedKeys: setSelectedKeys,
    disabledKeys: disabledKeysProp
  };
}

function $c86d35e876e048ac11515eee40c7$var$convertSelection(selection, defaultValue) {
  if (!selection) {
    return defaultValue;
  }

  return selection === 'all' ? 'all' : new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(selection);
}
/**
 * An interface for reading and updating multiple selection state.
 */


export var SelectionManager = /*#__PURE__*/function () {
  function SelectionManager(collection, state, options) {
    _classCallCheck(this, SelectionManager);

    var _options$allowsCellSe;

    this.collection = void 0;
    this.state = void 0;
    this.allowsCellSelection = void 0;
    this._isSelectAll = void 0;
    this.collection = collection;
    this.state = state;
    this.allowsCellSelection = (_options$allowsCellSe = options == null ? void 0 : options.allowsCellSelection) != null ? _options$allowsCellSe : false;
    this._isSelectAll = null;
  }
  /**
   * The type of selection that is allowed in the collection.
   */


  _createClass(SelectionManager, [{
    key: "selectionMode",
    get: function get() {
      return this.state.selectionMode;
    }
    /**
     * Whether the collection allows empty selection.
     */

  }, {
    key: "disallowEmptySelection",
    get: function get() {
      return this.state.disallowEmptySelection;
    }
    /**
     * Whether the collection is currently focused.
     */

  }, {
    key: "isFocused",
    get: function get() {
      return this.state.isFocused;
    }
    /**
     * Sets whether the collection is focused.
     */

  }, {
    key: "setFocused",
    value: function setFocused(isFocused) {
      this.state.setFocused(isFocused);
    }
    /**
     * The current focused key in the collection.
     */

  }, {
    key: "focusedKey",
    get: function get() {
      return this.state.focusedKey;
    }
    /** Whether the first or last child of the focused key should receive focus. */

  }, {
    key: "childFocusStrategy",
    get: function get() {
      return this.state.childFocusStrategy;
    }
    /**
     * Sets the focused key.
     */

  }, {
    key: "setFocusedKey",
    value: function setFocusedKey(key, childFocusStrategy) {
      this.state.setFocusedKey(key, childFocusStrategy);
    }
    /**
     * The currently selected keys in the collection.
     */

  }, {
    key: "selectedKeys",
    get: function get() {
      return this.state.selectedKeys === 'all' ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
    }
    /**
     * The raw selection value for the collection.
     * Either 'all' for select all, or a set of keys.
     */

  }, {
    key: "rawSelection",
    get: function get() {
      return this.state.selectedKeys;
    }
    /**
     * Returns whether a key is selected.
     */

  }, {
    key: "isSelected",
    value: function isSelected(key) {
      if (this.state.selectionMode === 'none') {
        return false;
      }

      key = this.getKey(key);
      return this.state.selectedKeys === 'all' ? !this.state.disabledKeys.has(key) : this.state.selectedKeys.has(key);
    }
    /**
     * Whether the selection is empty.
     */

  }, {
    key: "isEmpty",
    get: function get() {
      return this.state.selectedKeys !== 'all' && this.state.selectedKeys.size === 0;
    }
    /**
     * Whether all items in the collection are selected.
     */

  }, {
    key: "isSelectAll",
    get: function get() {
      if (this.isEmpty) {
        return false;
      }

      if (this.state.selectedKeys === 'all') {
        return true;
      }

      if (this._isSelectAll != null) {
        return this._isSelectAll;
      }

      var allKeys = this.getSelectAllKeys();
      var selectedKeys = this.state.selectedKeys;
      this._isSelectAll = allKeys.every(function (k) {
        return selectedKeys.has(k);
      });
      return this._isSelectAll;
    }
  }, {
    key: "firstSelectedKey",
    get: function get() {
      var _first;

      var first = null;

      var _iterator = _createForOfIteratorHelper(this.state.selectedKeys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var item = this.collection.getItem(key);

          if (!first || (item == null ? void 0 : item.index) < first.index) {
            first = item;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return (_first = first) == null ? void 0 : _first.key;
    }
  }, {
    key: "lastSelectedKey",
    get: function get() {
      var _last;

      var last = null;

      var _iterator2 = _createForOfIteratorHelper(this.state.selectedKeys),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var item = this.collection.getItem(key);

          if (!last || (item == null ? void 0 : item.index) > last.index) {
            last = item;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return (_last = last) == null ? void 0 : _last.key;
    }
    /**
     * Extends the selection to the given key.
     */

  }, {
    key: "extendSelection",
    value: function extendSelection(toKey) {
      toKey = this.getKey(toKey);
      var selection; // Only select the one key if coming from a select all.

      if (this.state.selectedKeys === 'all') {
        selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection([toKey], toKey, toKey);
      } else {
        var selectedKeys = this.state.selectedKeys;
        var anchorKey = selectedKeys.anchorKey || toKey;
        selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(selectedKeys, anchorKey, toKey);

        var _iterator3 = _createForOfIteratorHelper(this.getKeyRange(anchorKey, selectedKeys.currentKey || toKey)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var key = _step3.value;
            selection.delete(key);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        var _iterator4 = _createForOfIteratorHelper(this.getKeyRange(toKey, anchorKey)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _key = _step4.value;

            if (!this.state.disabledKeys.has(_key)) {
              selection.add(_key);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getKeyRange",
    value: function getKeyRange(from, to) {
      var fromItem = this.collection.getItem(from);
      var toItem = this.collection.getItem(to);

      if (fromItem && toItem) {
        if (fromItem.index <= toItem.index) {
          return this.getKeyRangeInternal(from, to);
        }

        return this.getKeyRangeInternal(to, from);
      }

      return [];
    }
  }, {
    key: "getKeyRangeInternal",
    value: function getKeyRangeInternal(from, to) {
      var keys = [];
      var key = from;

      while (key) {
        var item = this.collection.getItem(key);

        if (item && item.type === 'item' || item.type === 'cell' && this.allowsCellSelection) {
          keys.push(key);
        }

        if (key === to) {
          return keys;
        }

        key = this.collection.getKeyAfter(key);
      }

      return [];
    }
  }, {
    key: "getKey",
    value: function getKey(key) {
      var item = this.collection.getItem(key);

      if (!item) {
        // ¯\_(ツ)_/¯
        return key;
      } // If cell selection is allowed, just return the key.


      if (item.type === 'cell' && this.allowsCellSelection) {
        return key;
      } // Find a parent item to select


      while (item.type !== 'item' && item.parentKey) {
        item = this.collection.getItem(item.parentKey);
      }

      if (!item || item.type !== 'item') {
        return null;
      }

      return item.key;
    }
    /**
     * Toggles whether the given key is selected.
     */

  }, {
    key: "toggleSelection",
    value: function toggleSelection(key) {
      key = this.getKey(key);

      if (key == null) {
        return;
      }

      var keys = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection(this.state.selectedKeys === 'all' ? this.getSelectAllKeys() : this.state.selectedKeys);

      if (keys.has(key)) {
        keys.delete(key); // TODO: move anchor to last selected key...
        // Does `current` need to move here too?
      } else {
        keys.add(key);
        keys.anchorKey = key;
        keys.currentKey = key;
      }

      if (this.disallowEmptySelection && keys.size === 0) {
        return;
      }

      this.state.setSelectedKeys(keys);
    }
    /**
     * Replaces the selection with only the given key.
     */

  }, {
    key: "replaceSelection",
    value: function replaceSelection(key) {
      key = this.getKey(key);

      if (key == null) {
        return;
      }

      this.state.setSelectedKeys(new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection([key], key, key));
    }
    /**
     * Replaces the selection with the given keys.
     */

  }, {
    key: "setSelectedKeys",
    value: function setSelectedKeys(keys) {
      if (this.selectionMode === 'none') {
        return;
      }

      var selection = new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection();

      var _iterator5 = _createForOfIteratorHelper(keys),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var key = _step5.value;
          key = this.getKey(key);

          if (key != null) {
            selection.add(key);

            if (this.selectionMode === 'single') {
              break;
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.state.setSelectedKeys(selection);
    }
  }, {
    key: "getSelectAllKeys",
    value: function getSelectAllKeys() {
      var _this2 = this;

      var keys = [];

      var addKeys = function addKeys(key) {
        while (key) {
          if (!_this2.state.disabledKeys.has(key)) {
            var item = _this2.collection.getItem(key);

            if (item.type === 'item') {
              keys.push(key);
            } // Add child keys. If cell selection is allowed, then include item children too.


            if (item.hasChildNodes && (_this2.allowsCellSelection || item.type !== 'item')) {
              addKeys(_toConsumableArray(item.childNodes)[0].key);
            }
          }

          key = _this2.collection.getKeyAfter(key);
        }
      };

      addKeys(this.collection.getFirstKey());
      return keys;
    }
    /**
     * Selects all items in the collection.
     */

  }, {
    key: "selectAll",
    value: function selectAll() {
      if (this.selectionMode === 'multiple') {
        this.state.setSelectedKeys('all');
      }
    }
    /**
     * Removes all keys from the selection.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (!this.disallowEmptySelection && (this.state.selectedKeys === 'all' || this.state.selectedKeys.size > 0)) {
        this.state.setSelectedKeys(new $c91e86e24f2dc9a2182dcc2674c58c$export$Selection());
      }
    }
    /**
     * Toggles between select all and an empty selection.
     */

  }, {
    key: "toggleSelectAll",
    value: function toggleSelectAll() {
      if (this.isSelectAll) {
        this.clearSelection();
      } else {
        this.selectAll();
      }
    }
  }, {
    key: "select",
    value: function select(key, e) {
      if (this.selectionMode === 'none') {
        return;
      }

      if (this.selectionMode === 'single') {
        if (this.isSelected(key) && !this.disallowEmptySelection) {
          this.toggleSelection(key);
        } else {
          this.replaceSelection(key);
        }
      } else if (e && e.shiftKey) {
        this.extendSelection(key);
      } else {
        this.toggleSelection(key);
      }
    }
    /**
     * Returns whether the current selection is equal to the given selection.
     */

  }, {
    key: "isSelectionEqual",
    value: function isSelectionEqual(selection) {
      if (selection === this.state.selectedKeys) {
        return true;
      } // Check if the set of keys match.


      var selectedKeys = this.selectedKeys;

      if (selection.size !== selectedKeys.size) {
        return false;
      }

      var _iterator6 = _createForOfIteratorHelper(selection),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var key = _step6.value;

          if (!selectedKeys.has(key)) {
            return false;
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var _iterator7 = _createForOfIteratorHelper(selectedKeys),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _key2 = _step7.value;

          if (!selection.has(_key2)) {
            return false;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return true;
    }
  }]);

  return SelectionManager;
}();